module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/default-c9220a23a3634440c3d7f1e6cf43509d.svg";